export default __webpack_public_path__ + "static/2-bfcf5aec574758b9a3a6c111683fb222.jpg";